import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../../__root";

export const customerLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "$customerId",
}).lazy(() => import("./Dashboard.lazy").then((d) => d.Route));

/** @deprecated Use `customerLayoutRoute` — kept for gradual migration of imports. */
export const dashboardRoute = customerLayoutRoute;
